import React from 'react';
import { Card, Placeholder } from 'react-bootstrap';
import { useScreenResize } from '../../../../shared/hooks/useScreenResize';

export function AgencyCardItemSkeleton() {
    const { width } = useScreenResize();
    const isBigScreen = width > 1600;

    return (
        <div className={`col-md-6 col-lg-4 ${isBigScreen ? 'col-xl-3' : ''} d-flex`} aria-hidden="true">
            <Card className="brand-card w-100 placeholder-glow">
                <div className="position-relative">
                    <Placeholder
                        className="skeleton skeleton-agency-card-image"
                        style={{ height: isBigScreen ? 280 : 250 }}
                    />
                    <div className="place-top-right">
                        <Placeholder className="skeleton skeleton-agency-flag" />
                    </div>
                    <Placeholder className="skeleton skeleton-agency-circle" />
                </div>

                <div className="p-3">
                    <Placeholder xs={7} className="skeleton skeleton-title d-block mb-3" />
                    <div className="d-flex align-items-center justify-content-between mt-2">
                        {Array.from({ length: 3 }).map((_, i) => (
                            <div
                                key={i}
                                className={`card py-3 flex-grow-1 d-flex align-items-center flex-column ${
                                    i === 1 ? 'mx-2' : ''
                                }`}
                            >
                                <Placeholder className="skeleton skeleton-header-icon" />
                                <Placeholder className="skeleton skeleton-table-cell skeleton-table-cell-sm mt-1" />
                            </div>
                        ))}
                    </div>

                    <div className="mt-4">
                        {Array.from({ length: 3 }).map((_, i) => (
                            <div key={i} className="d-flex align-items-center mb-3">
                                <Placeholder className="skeleton skeleton-table-name" />
                                <Placeholder className="skeleton skeleton-table-cell skeleton-table-cell-sm ml-1" />
                            </div>
                        ))}
                    </div>
                </div>

                <Card.Footer>
                    <div className="d-flex justify-content-between align-items-center">
                        <div className="d-flex align-items-center">
                            {Array.from({ length: 3 }).map((_, i) => (
                                <Placeholder
                                    key={i}
                                    className="skeleton skeleton-message-avatar"
                                    style={{ marginLeft: i > 0 ? -12 : 0 }}
                                />
                            ))}
                        </div>
                        <div className="d-flex align-items-center">
                            <Placeholder
                                className="skeleton skeleton-outline-btn mr-2"
                                style={{ width: 38, height: 31 }}
                            />
                            <Placeholder className="skeleton skeleton-action-btn skeleton-btn-sm" />
                        </div>
                    </div>
                </Card.Footer>
            </Card>
        </div>
    );
}
